/**
 * Compact "nearby accommodation" list shown on each operational site card
 * (CustomerDetail). Top 5 vetted places within 25 miles of the site, nearest
 * first — unsuitable ones struck through with the booker's warning. Links to
 * the full directory pre-filtered to this site for booking, adding and rating.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RatingChip } from '../pages/Accommodation';
import '../pages/Accommodation.css';

function SiteNearbyAccommodation({ siteId }) {
  const { authFetch } = useAuth();
  const [rows, setRows] = useState(null);
  const [warning, setWarning] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await authFetch(`/api/v1/accommodation?site_id=${siteId}&limit=5`);
        const data = await response.json().catch(() => ({}));
        if (cancelled) return;
        if (response.ok) {
          setRows(data.data || []);
          setWarning(data.warning || null);
        } else {
          setRows([]);
        }
      } catch {
        if (!cancelled) setRows([]);
      }
    })();
    return () => { cancelled = true; };
  }, [authFetch, siteId]);

  if (rows === null) return <div className="site-accom-list">Loading…</div>;

  return (
    <div className="site-accom-list">
      {warning ? (
        <p className="accom-history-empty">{warning}</p>
      ) : rows.length === 0 ? (
        <p className="accom-history-empty">Nothing logged within 25 miles yet.</p>
      ) : (
        rows.map(row => (
          <div key={row.accommodation_id} className={`site-accom-row ${row.is_suitable === false ? 'unsuitable' : ''}`}>
            <span className="site-accom-name">{row.name}</span>
            <span className="site-accom-distance">{row.distance_miles} mi</span>
            <RatingChip avgRating={row.avg_rating} stayCount={row.stay_count} />
            {row.is_suitable === false && (
              <span className="site-accom-reason">Not suitable{row.unsuitable_reason ? ` — ${row.unsuitable_reason}` : ''}</span>
            )}
          </div>
        ))
      )}
      <div className="site-accom-footer">
        <Link to={`/accommodation?site_id=${siteId}`}>View directory / add nearby →</Link>
      </div>
    </div>
  );
}

export default SiteNearbyAccommodation;
